import { Link } from "react-router-dom";
import { ChevronRight, ArrowLeft } from "lucide-react";
import { images } from "@/config/content";
import { useLang } from "@/i18n/LanguageContext";
import { Seo } from "@/components/Seo";
import { Overline } from "@/components/Reveal";
import { CallButton, WhatsAppButton } from "@/components/ActionButtons";

// Shared compact page for the rental / sales areas (structure ready, content to come).
export function MobilityPage({ variant }) {
  const { t, lang } = useLang();
  const m = t.mobility;
  const isRent = variant === "rent";
  const title = isRent ? m.rentTitle : m.saleTitle;
  const text = isRent ? m.rentText : m.saleText;
  const image = isRent ? images.rentalCar : images.saleCar;
  const path = isRent ? "/noleggio-auto" : "/auto-in-vendita";

  return (
    <>
      <Seo title={`${title} | EMME SERVICE CAR`} description={text} path={path} />
      <section className="relative overflow-hidden pb-8 pt-32">
        <div className="absolute inset-0 z-0">
          <img src={image} alt={title} className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/85 to-carbon/70" />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 lg:px-8">
          <nav aria-label="Breadcrumb" className="mb-6 flex items-center gap-2 text-xs text-steel">
            <Link to="/" className="hover:text-amber">{t.breadcrumbHome}</Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-ice">{title}</span>
          </nav>
          <Overline>{m.overline}</Overline>
          <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-ice sm:text-5xl">{title}</h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-steel">{text}</p>
        </div>
      </section>

      <section className="bg-carbon pb-24">
        <div className="mx-auto max-w-4xl px-6 lg:px-8">
          <div className="rounded-2xl border border-dashed border-edge bg-asphalt/60 p-8 text-center" data-testid="mobility-page-soon">
            <p className="mx-auto max-w-lg text-sm leading-relaxed text-steel">{m.soon}</p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <CallButton size="lg" testId="mobility-page-call" />
              <WhatsAppButton size="lg" testId="mobility-page-whatsapp" />
            </div>
          </div>
          <div className="mt-8 text-center">
            <Link to="/#mobilita" className="inline-flex items-center gap-2 text-sm font-bold text-amber hover:underline">
              <ArrowLeft className="h-4 w-4" /> {lang === "en" ? "Back to home" : "Torna alla home"}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export function Noleggio() {
  return <MobilityPage variant="rent" />;
}

export function Vendita() {
  return <MobilityPage variant="sale" />;
}
